<template>
  <v-btn
    id="btn"
    to="/"
    class="ml-2"
    min-width="0"
    text
    fab
  >
    <router-link
      to="/carrinho"
    >
      <v-icon
        :color="corPrimaria"
        label="carrinho.length"
      >
        mdi-cart-variant
      </v-icon>
      <span
        id="span"
        :color="corPrimaria"
      >
        {{ cart }}
      </span>
    </router-link>
  </v-btn>
</template>

<script>
  export default {
    name: 'DashboardCoreCart',

    props: {
      cart: {
        type: Number,
        default: 0,
      },
    },

    data: () => ({
      styleObject: {
        color: localStorage.corPrimaria,
      },
      corPrimaria: localStorage.corPrimaria,
    }),

    watch: {
      cart (cart) {
        this.cart = cart
      },
    },
  }
</script>

<style lang="sass">
  #btn
    position: relative
    top: 55px
    left: 82em
    border-radius: 8px
    cursor: pointer

  #span
    background: black none repeat scroll 0% 0%
    border-radius: 50%
    text-align: center
    display: flex
    font-weight: bold
    height: 2rem
    justify-content: center
    padding: 0.5rem
    position: absolute
    right: 5px
    top: -14px
    width: 2rem
    transform: scale(.8)
    opacity: 0.25
    color: white

</style>
